function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#060"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v10.714H0V7.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v4.286H0v-4.286Z",
    style: {
      fill: "#c00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4,14.794c.074-.128.238-.171.366-.097.08.046.13.131.133.223v1.071h.201v-1.071c.005-.148.128-.264.276-.26.092.003.177.053.223.133.11-.331-.07-.689-.401-.799s-.689.07-.799.401c-.042.13-.042.269,0,.399",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.544,14.514c.18-.037.364.046.456.205.092-.159.276-.242.456-.205-.035-.252-.267-.428-.519-.394-.204.028-.365.189-.393.394",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M14.899,15.563c-.04.448-.436.778-.884.738-.181-.016-.352-.093-.484-.217-.173.434-.665.646-1.1.473-.064-.025-.125-.059-.18-.099.078.781,1.248.621,1.335-.138.368.645,1.176.461,1.412-.33l-.099-.427Z",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M15.101,15.563c.04.448.436.778.884.738.181-.016.352-.093.484-.217.173.434.665.646,1.1.473.064-.025.125-.059.18-.099-.078.781-1.248.621-1.335-.138-.368.645-1.176.461-1.412-.33l.099-.427Z",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M14.118,16.949c-.163.352-.49.413-.775.128,0,0,.115-.081.238-.103-.023-.098.024-.234.091-.307.07.048.167.143.192.254.171-.021.254.029.254.028h0Z",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1",
    "data-name": "b",
    d: "M15.395,16.91c-.218.321-.55.328-.786,0,0,0,.126-.061.251-.063-.007-.1.062-.227.14-.288.061.058.142.169.148.282.174.005.247.068.247.068h0Z",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2",
    "data-name": "b",
    d: "M16.662,17.078c-.268.281-.596.234-.775-.127,0,0,.135-.04.258-.022.01-.1.098-.213.185-.261.051.068.112.189.1.303.169.034.232.107.232.107h0Z",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.03,17.9c-1.328-.395-2.732-.395-4.059,0l-.098-.329c1.392-.414,2.863-.414,4.255,0l-.098.329Z",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M14.529,12.35l1.019.24-.965.405.543-.895.087,1.043-.684-.793Z",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c1",
    "data-name": "c",
    d: "M13.029,12.752l1.019.24-.965.405.543-.895.087,1.043-.684-.793Z",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c2",
    "data-name": "c",
    d: "M11.931,13.85l1.019.24-.965.405.543-.895.087,1.043-.684-.793Z",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c3",
    "data-name": "c",
    d: "M11.529,15.35l1.019.24-.965.405.543-.895.087,1.043-.684-.793Z",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c4",
    "data-name": "c",
    d: "M16.971,12.752l-1.019.24.965.405-.543-.895-.087,1.043.684-.793Z",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c5",
    "data-name": "c",
    d: "M18.069,13.85l-1.019.24.965.405-.543-.895-.087,1.043.684-.793Z",
    style: {
      fill: "#f8c300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c6",
    "data-name": "c",
    d: "M18.471,15.35l-1.019.24.965.405-.543-.895-.087,1.043.684-.793Z",
    style: {
      fill: "#f8c300"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/TJ.1f4744e47a3b8297a639f5d92ffcbd87.svg";
export { ForwardRef as ReactComponent };